import React, { useState } from 'react';
import { galleryImages } from '../data/mockData';

const Gallery = () => {
  const [selectedCategory, setSelectedCategory] = useState('All');
  
  const categories = ['All', ...new Set(galleryImages.map(img => img.category))];
  
  const filteredImages = selectedCategory === 'All' 
    ? galleryImages 
    : galleryImages.filter(img => img.category === selectedCategory);

  return (
    <div>
      {/* Hero Section */}
      <section style={{ 
        background: 'var(--bg-secondary)',
        padding: '80px 0',
        borderBottom: '1px solid var(--border-light)'
      }}>
        <div className="container">
          <h1 className="hero-large" style={{ marginBottom: '16px' }}>
            Gallery
          </h1>
          <p className="body-large" style={{ color: 'var(--text-secondary)' }}>
            View our state-of-the-art facilities and beautiful smile transformations
          </p>
        </div>
      </section>

      {/* Filter Section */}
      <section style={{ 
        padding: '40px 0',
        borderBottom: '1px solid var(--border-light)'
      }}>
        <div className="container">
          <div style={{
            display: 'flex',
            gap: '12px',
            flexWrap: 'wrap',
            justifyContent: 'center'
          }}>
            {categories.map(category => (
              <button
                key={category}
                onClick={() => setSelectedCategory(category)}
                className="body-regular"
                style={{
                  padding: '12px 24px',
                  background: selectedCategory === category ? 'var(--interactive-base)' : 'transparent',
                  color: selectedCategory === category ? 'var(--bg-primary)' : 'var(--text-primary)',
                  border: `1px solid ${selectedCategory === category ? 'var(--interactive-base)' : 'var(--border-medium)'}`,
                  borderRadius: '0px',
                  cursor: 'pointer',
                  fontFamily: 'Suisse Medium, sans-serif',
                  fontWeight: selectedCategory === category ? 700 : 400,
                  transition: 'all 0.2s ease'
                }}
              >
                {category}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="section-padding">
        <div className="container">
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
            gap: '24px'
          }}>
            {filteredImages.map((image) => (
              <div 
                key={image.id}
                style={{
                  position: 'relative',
                  overflow: 'hidden',
                  borderRadius: '0px',
                  border: '1px solid var(--border-light)',
                  cursor: 'pointer',
                  transition: 'transform 0.2s ease'
                }}
                className="gallery-item"
              >
                <img 
                  src={image.url}
                  alt={image.title}
                  style={{
                    width: '100%',
                    height: '280px',
                    objectFit: 'cover',
                    display: 'block'
                  }}
                />
                <div style={{
                  padding: '16px',
                  background: 'var(--bg-primary)'
                }}>
                  <div className="body-regular" style={{ marginBottom: '4px' }}>
                    {image.title}
                  </div>
                  <div className="body-small" style={{ color: 'var(--text-secondary)' }}>
                    {image.category}
                  </div>
                </div>
              </div>
            ))}
          </div>

          {filteredImages.length === 0 && (
            <div style={{ textAlign: 'center', padding: '80px 0' }}>
              <p className="body-large" style={{ color: 'var(--text-secondary)' }}>
                No images found in this category
              </p>
            </div>
          )}
        </div>
      </section>

      <style jsx>{`
        .gallery-item:hover {
          transform: translateY(-4px);
        }
      `}</style>
    </div>
  );
};

export default Gallery;
